<div
  class="login-root onboarding-root vh-100 position-relative overflow-hidden bg-primary"
  :style="onboardingBackgroundStyle"
>
  <div class="container-fluid position-relative h-100 px-4 px-lg-5 py-3 py-lg-4">
    <div class="d-flex flex-column h-100">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <div class="login-card onboarding-card w-100 mx-auto px-4 px-sm-4 py-4 rounded-4">
          <div class="text-center mb-3">
            <img :src="$clientLogo" class="img-fluid" width="200" />
          </div>

          <h5 class="text-center onboarding-title mt-5">{{ title }}</h5>

          <form @submit.prevent="submitForm" class="mx-auto onboarding-form">
            <div class="mb-3">
              <slot name="form-content"></slot>
            </div>

            <button
              v-if="show_default_submit_button"
              type="submit"
              class="btn btn-primary-dark w-100 py-3 fw-semibold"
              :disabled="verification_running"
            >
              {{ submit_button_text }}
            </button>

            <div class="mt-3">
              <slot name="custom-button"></slot>
            </div>

            <div class="mt-4 text-center">
              <slot name="signup-content"></slot>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
